module.exports = __webpack_public_path__ + "img/employees.646563b.webp";